// extracted by mini-css-extract-plugin
export default {"cell":"CardholderCell_cell__F8TAo","holder":"CardholderCell_holder__7grDu","ending":"CardholderCell_ending__D90nT","muted":"CardholderCell_muted__jOvXV"};